import { IconActionTrash, IconPencilDraw, IconThreeDotsVertical } from '@/theme/icons';
import rem from '@/utils/rem';
import { Icon, IconButton, Menu, MenuButton, MenuItem, MenuList, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { BsPlusLg } from 'react-icons/bs';

type Props = {
  onCreateAction: () => void;
  onCreateBlock: () => void;
  onEdit: () => void;
  onRemove: () => void;
};

const ThreeDotsKeyResultButton = ({ onCreateAction, onCreateBlock, onEdit, onRemove }: Props) => {
  const { t } = useTranslation('ProjectDetailComponents');
  return (
    <Menu isLazy>
      <Tooltip label={t('keyResult.sectionTitle')} placement="top">
        <MenuButton
          as={IconButton}
          width="auto"
          height="auto"
          padding={rem(2.5)}
          borderRadius={rem(6)}
          _hover={{
            backgroundColor: 'gray.950',
          }}
          __css={{
            justifyContent: 'center',
            display: 'flex',
            alignItems: 'center',
          }}
          aria-label={t('keyResult.sectionTitle')}
          icon={<Icon as={IconThreeDotsVertical} boxSize={rem(14)} margin="0 auto" color="text-primary" />}
          variant="unstyled"
        />
      </Tooltip>
      <MenuList
        zIndex="dropdown"
        minWidth="0"
        borderWidth={rem(1)}
        borderStyle="solid"
        borderColor="gray.700"
        borderRadius="4"
        backgroundColor="background-primary"
        paddingX={rem(8)}
      >
        <MenuItem
          textStyle="small"
          marginBottom={rem(8)}
          padding={`${rem(4)} ${rem(8)}`}
          color="text-primary"
          _hover={{ backgroundColor: 'background-secondary' }}
          backgroundColor="inherit"
          icon={<Icon as={IconPencilDraw} boxSize={rem(14)} color="text-primary" />}
          iconSpacing={rem(8)}
          onClick={onEdit}
        >
          {t('keyResult.edit')}
        </MenuItem>
        <MenuItem
          textStyle="small"
          marginBottom={rem(8)}
          padding={`${rem(4)} ${rem(8)}`}
          color="text-primary"
          _hover={{ backgroundColor: 'background-secondary' }}
          backgroundColor="inherit"
          icon={<Icon as={BsPlusLg} boxSize={rem(14)} color="text-primary" />}
          iconSpacing={rem(8)}
          onClick={onCreateAction}
        >
          {t('keyResult.createAction')}
        </MenuItem>
        <MenuItem
          textStyle="small"
          marginBottom={rem(8)}
          padding={`${rem(4)} ${rem(8)}`}
          color="text-primary"
          _hover={{ backgroundColor: 'background-secondary' }}
          backgroundColor="inherit"
          icon={<Icon as={BsPlusLg} boxSize={rem(14)} color="text-primary" />}
          iconSpacing={rem(8)}
          onClick={onCreateBlock}
        >
          {t('keyResult.createBlock')}
        </MenuItem>
        <MenuItem
          textStyle="small"
          padding={`${rem(4)} ${rem(8)}`}
          color="red.500"
          borderRadius="4"
          _hover={{ backgroundColor: 'background-secondary' }}
          backgroundColor="inherit"
          icon={<Icon as={IconActionTrash} boxSize={rem(14)} />}
          onClick={onRemove}
        >
          {t('keyResult.delete')}
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default ThreeDotsKeyResultButton;
